import React from "react";
import { Helmet } from "react-helmet-async";

const title = "Shipping & Logistics Service Policy | Shivam Shipping & Logistics";
const description =
  "Read Shivam Shipping & Logistics's Shipping & Logistics Service Policy. Learn how we handle maritime logistics, timelines, and service fulfillment.";
const keywords =
  "shipping services, logistics policy, Shivam Shipping & Logistics, maritime logistics Vizag, cargo handling delivery, port operations";
const ogImage = " ";
const canonical = "https://shivamshippingandlogistics-scm.com/Legal/shipping-and-delivery";

const ShippingandDelivery = () => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Shivam Shipping & Logistics" />
        <meta name="language" content="en" />
        <meta name="distribution" content="global" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        {/* Canonical Link */}
        <link rel="canonical" href={canonical} />
      </Helmet>

      <div className="disclaimer px-5 mt-6 text-black mx-4">
        <h1 className="text-center text-2xl py-10 font-bold">
          Shipping & Logistics Service Policy
        </h1>
        <p>Last updated: 2024-01-01</p>
        <br />
        <p className="text-lg font-medium">
          Service Fulfillment & Timelines
        </p>
        <p className="py-2">
          At Shivam Shipping & Logistics, we provide maritime logistics and supply chain services. Our "delivery" refers to the successful execution of these services, including but not limited to vessel agency, stevedoring, and customs clearance.
        </p>
        <p className="py-2">
          Service timelines are subject to vessel arrival schedules, port authority regulations, and weather conditions. We strive to maintain the highest efficiency in all our port operations across Visakhapatnam, Paradip, and other major ports.
        </p>
        <p className="py-2">
          Documentation and status updates are provided to clients through our dedicated communication channels and tracking systems.
        </p>
      </div>
    </>
  );
};

export default ShippingandDelivery;
